import {runStartupVersionGuard, installChunkLoadRecovery} from './utils/startupGuard'

const version = require('../package.json').version
runStartupVersionGuard(version)
installChunkLoadRecovery()


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/vantui"
import "reset-css"
import '@/components/vant.js'
import VueRouter from 'vue-router'
import {getEdition,loginTime} from "@/request/api";

// 创建事件总线
const EventBus = new Vue()

// 将事件总线挂载到Vue原型上，以便在任何组件中都能访问
Vue.prototype.$EventBus = EventBus

import Print from 'vue-print-nb'
Vue.use(Print)

// 引入 echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import  VueTouch from 'vue-touch'
Vue.use(VueTouch,{name:'v-touch'})
VueTouch.config.swipe = {
  threshold:5,  //手指左右滑动距离
  direction: "horizontal"//解决无法上下滑动

}

// import "@/assets/swiper.min.css";



// 手机适配
import 'amfe-flexible';
import 'amfe-flexible/index.js';

import MetaInfo from 'vue-meta-info'
//vant
import VueClipBoard from 'vue-clipboard2'
import {Toast, Loading, Overlay, Field, Form,Switch,Area,RadioGroup, Radio} from 'vant';
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Field);
Vue.use(Form);
Vue.use(Switch);
Vue.use(Area);
Vue.use(RadioGroup);
Vue.use(Radio);



Vue.use(VueClipBoard)

Vue.use(MetaInfo);
Vue.use(VueRouter);
Vue.config.ignoredElements = [...Vue.config.ignoredElements, 'wx-open-launch-weapp']

// const app = Vue.use(App);
// console.log(app);
// console.log(app.config.globalProperties);
// import Video from 'video.js'
// import 'video.js/dist/video-js.css'
// Vue.prototype.$video = Video


// import Vue from 'vue'
// import VideoPlayer from 'vue-video-player/src'
// import 'video.js/dist/video-js.css'
// require('vue-video-player/node_modules/video.js/dist/video-js.css') 
// require('vue-video-player/src/custom-theme.css') 
// Vue.use(VideoPlayer)

// 第一个是videoJs的样式，后一个是vue-video-player的样式，因为考虑到我其他业务组件可能也会用到视频播放，所以就放在了main.js内
// import VideoPlayer from 'vue-video-player/src';
// import 'vue-video-player/src/custom-theme.css';
// import 'video.js/dist/video-js.css'
// Vue.use(VideoPlayer)

import videoPlayer  from 'vue-video-player';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(videoPlayer );

Vue.prototype.getToken = function (){
  return localStorage.getItem("token");
}
Vue.prototype.getBranch = function (){
  let branch = localStorage.getItem("branchId");
  if(branch == 'null' || branch == '') {
    return 1;
  }
  return (branch ? branch : 1);
}
Vue.prototype.getGroupId= function (){
  return localStorage.getItem("groupId");
}
Vue.prototype.getSubjectId = function (){
  return localStorage.getItem("subjectId");
}
Vue.prototype.getAdminId = function (){
  let adminId = localStorage.getItem("adminId");
  if(adminId == 'null' || adminId == '') {
    return 1;
  }
  return (adminId ? adminId : 1);
}
Vue.prototype.getUserDetail = function (){
  return JSON.parse(localStorage.getItem("userInfo"));
}
Vue.prototype.getBranchCompany = function (){
  let title = localStorage.getItem("title");
  if(title == 'null' || title == '' || title == 'undefined') {
    return '手机网校';
  }
  return (title ? title : '手机网校')
}
Vue.prototype.getStrNumber = function (number){
  var numReg = /^[0-9]*$/
  var numRe = new RegExp(numReg)
  console.log(numRe.test(number));
  if (!numRe.test(number)) {
    return false
  }
  return true;
}
Vue.prototype.getUrlParameter = function (){
  let data = location.href.split('/')
  let len = data.length;
  let num = data[len-1];
  var numReg = /^[0-9]*$/
  var numRe = new RegExp(numReg)
  let url = location.href;
  if (!numRe.test(num)) {
    url = location.href+'/'+this.getBranch();
  }
  // console.log(url);
  return url;
}
Vue.prototype.getAppLogin = function (){
  let type = localStorage.getItem("appLogin");
  if(type) {
    return true;
  }
  return false;
}
Vue.prototype.getIcoUrl = function (icoUrl){
  var link= document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = icoUrl
  document.getElementsByTagName('head')[0].appendChild(link);
}
window.getEdition = function() {
  getEdition()
      .then(res => {
        if(res.data.code == 1) {
          localStorage.setItem('edition',res.data.data.edition)
        }
      })
      .catch(err => {
        localStorage.setItem('edition',1.0)
      })
  var  edition = localStorage.getItem('edition')
  return localStorage.getItem('version');
}
window.setHandoutTime = function(handoutTime) {
  // this.handoutUpdate(handoutTime);
  Vue.prototype.$EventBus.$emit('callYourMethod',handoutTime)
}
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
]
Vue.prototype.isWeiXin = function(){
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  } else{
    return false;
  }
}
Vue.prototype.loginTimer = null;
Vue.prototype.stopLoginTimer = function(){
  if (this.loginTimer != null) clearInterval(this.loginTimer)
  this.loginTimer = null
}
Vue.prototype.loginTime = function(){
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.match(/MicroMessenger/i) != 'micromessenger'){
    if(window.android != undefined) {
      if(window.android.isapp() == true) {
        return false;
      }
    }
  }
  const that = Vue.prototype;
  that.stopLoginTimer();
  if(that.getToken()) {
    that.loginTimer = setInterval(() => {
      // console.log('调用定时');
      loginTime()
          .then(res => {
            if(res.data.code == 401) {
              Toast.fail(res.data.msg);
              //清除登录 重新登录
              localStorage.removeItem("token");
              localStorage.removeItem("userInfo");
              that.stopLoginTimer()
              window.parent.location.reload();
              window.location.href='#/user'
            } else {
              if(res.data.data.jwt && res.data.data.jwt != '') {
                localStorage.setItem("token", res.data.data.jwt);
              }
            }
          })
          .catch(err => {
            Toast.fail('已过期，请重新登陆2');
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            that.stopLoginTimer()
            window.parent.location.reload();
            window.location.href='#/user'
          })
    }, 30000)
  }
}





Vue.filter("RMBformat", val => {
  return "¥" + Number(val).toFixed(2) + "元"
})

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
